import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[contentHost]',
})
export class FPContentHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
